import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GameGridFilterByEnum as FilterBy } from '../../../shared/src/enums/game-grid-filter-by.enum';
import { SubcategoriesActionsService as ActionsService } from '../services/SubcategoriesActions.service';
import { useDeviceTypeHook } from '../../../shared/src/hooks/use-device-type.hook';

export const useFilterOptionAvailability = () => {
    const { gameGridFilters } = useSelector((state) => state.app.rbcSettings);
    const { isMobile } = useDeviceTypeHook();
    const possibleFilterOptions = [
        FilterBy.PROVIDERS,
    ];

    const filterOptionsList = useMemo(() => ActionsService.getOptionsList({
        configs: gameGridFilters,
        isMobile,
    }), [gameGridFilters, isMobile]);

    const isAnyFilterOptionAvailable = useMemo(() => ActionsService.isAnyOptionAvailable({
        optionsToCheck: possibleFilterOptions,
        optionsList: filterOptionsList,
    }), [filterOptionsList]);

    return {
        filterOptionsList,
        isAnyFilterOptionAvailable,
    };
};
